/* eslint-disable react/require-default-props */
import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import SuccessIcon from '@material-ui/icons/Check';
import WarningIcon from '@material-ui/icons/Warning';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box, makeStyles, Typography,
} from '@material-ui/core';
import Button from '@trdk/style/Button';

const NotificationBox = ({
  variant, header = undefined, text, buttonText, buttonAction, buttonIcon, showIcon = false,
  children = undefined, className = '', margin = '0',
}) => {
  const classes = useStyles();
  const isAnyLowerContent = text || buttonText
    || (Array.isArray(children) ? children.some(c => c) : children);
  return (
    <Box
      padding="1.3rem"
      border="0.05rem solid #ccc"
      className={clsx(classes[`${variant}Box`], classes.notificationBox, className)}
      margin={margin}
    >
      {header && (
        <Box
          display="flex"
          flexDirection="row"
          marginBottom={isAnyLowerContent ? '0.5rem' : '0'}
        >
          {showIcon && (
            <>
              {variant === 'error' && <ErrorIcon className={classes.errorIcon} />}
              {variant === 'info' && <InfoIcon className={classes.infoIcon} />}
              {variant === 'warning' && <WarningIcon className={classes.warningIcon} />}
              {variant === 'success' && <SuccessIcon className={classes.successIcon} />}
            </>
          )}
          <Typography variant="h3" className={classes.header}>
            {header}
          </Typography>
        </Box>
      )}
      {text && (
        <Typography variant="body1">
          {text}
        </Typography>
      )}
      {children}
      {buttonText && (
        <Button
          startIcon={buttonIcon}
          onClick={buttonAction}
          className={classes.mt05}
          variant="contained"
          color="primary"
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};
NotificationBox.propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'error', 'success']).isRequired,
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  text: PropTypes.string,
  buttonText: PropTypes.string,
  buttonAction: PropTypes.func,
  buttonIcon: PropTypes.any,
  showIcon: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
  margin: PropTypes.string,
};
const useStyles = makeStyles(theme => ({
  mt05: {
    marginTop: '0.5rem',
  },
  errorIcon: {
    color: theme.palette.error.main,
    marginRight: '0.5rem',
  },
  infoIcon: {
    color: theme.palette.primary.main,
    marginRight: '0.5rem',
  },
  warningIcon: {
    color: theme.palette.warning.main,
    marginRight: '0.5rem',
  },
  successIcon: {
    color: theme.palette.success.main,
    marginRight: '0.5rem',
  },
  header: {
    fontSize: '1.25rem',
  },
  notificationBox: {
    borderRadius: '4px',
    borderWidth: '1px',
    borderStyle: 'solid',
  },
  successBox: {
    backgroundColor: '#f7fff6',
    borderColor: theme.palette.success.main,
  },
  errorBox: {
    backgroundColor: '#fce9e9',
    borderColor: theme.palette.error.main,
  },
  infoBox: {
    backgroundColor: '#f0f7ff',
    borderColor: theme.palette.primary.main,
  },
  warningBox: {
    backgroundColor: '#fff7eb',
    borderColor: theme.palette.warning.main,
  },
}));
export default NotificationBox;
